<template>
  <div class="wrapper">
    <div class="policydetail-wrap">
      <header class="top-head border-1px">
        <h1>Policy detail</h1>
      </header>
      <div class="empty border-1px"></div>
      <div class="companyInfo border-1px">
        <img src="../../assets/common/img/logo.png" alt="" />
        <div class="insuranceInfo">
          ”Auspicious Travel” Visiting Tourist Personal Accident Insurance
          <p>Application from No. : {{userInfo.policyNo}}</p>
        </div>
      </div>
      <div class="empty border-1px"></div>
      <div class="personInfo">
        <mt-field label="Applicant" placeholder="" v-model="userInfo.applicantName" readonly></mt-field>
        <mt-field label="Insured" placeholder="" v-model="userInfo.insuredName" readonly></mt-field>
        <!--<mt-field label="Gender" placeholder="" v-model="secrecy" readonly></mt-field>-->
        <!--<mt-field label="Nationality" placeholder="" v-model="secrecy" readonly></mt-field>-->
        <!--<mt-field label="Birthdate" placeholder="" v-model="secrecy" readonly></mt-field>-->
        <mt-field label="Type of ID" placeholder="" v-model="idType" readonly></mt-field>
        <mt-field label="ID number" placeholder="" v-model="userInfo.idNo" readonly></mt-field>
        <mt-field label="Date of entry" placeholder="" v-model="userInfo.approveDate" readonly></mt-field>
      </div>
      <div class="empty border-1px"></div>
      <div class="personInfo">
        <mt-field label="Insurance period" placeholder="" v-model="period" readonly></mt-field>
        <mt-field label="Permium" placeholder="" v-model="userInfo.permium" readonly></mt-field>
      </div>
      <div class="empty border-1px"></div>
      <mt-cell title="Insurance cluase" is-link @click.native="handleGo" :to="tourl"></mt-cell>
      <div class="empty border-1px"></div>
      <div class="sendBtnWrap">
        <mt-button type="default" @click.native="handlePrint">Download policy</mt-button>
        <mt-button type="default" @click.native="handleSend">Send to email</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import INTERFACE from '@/interface'
import { Field, Button, Radio, Header, InfiniteScroll, Cell, Popup } from 'mint-ui';
// import { Button } from 'mint-ui';

Vue.component(Header.name, Header)
Vue.component(Button.name, Button);
Vue.component(Field.name, Field);
Vue.component(Radio.name, Radio);
Vue.component(Cell.name, Cell);
Vue.component(Popup.name, Popup);
Vue.use(InfiniteScroll);
// Vue.use(Field)
export default {
  name: 'insurancePolicy',
  data() {
    return {
      I18n: window.I18n,
      tourl: '',
      username: 'Policy verification',
      policyId: '',
      period: 'Refer to the insurance clause in detail',
      idType: 'PASSPORT',
      focusState: false,
      filename: 'httpclient-tutorial.pdf',
      userInfo: {
        applicantName: '',
        insuredName: '',
        sex: '',
        nationality: '',
        birthday: '',
        permium: '',
        policyNo: ''
      }
    };
  },
  created() {
    // this.policyId = this.$route.params.policyId || ''
    this.policyId = this.$route.query.policyId;
    INTERFACE.getPolicyDetail({ policyId: this.policyId }).then((data) => {
      if (data.data) {
        data.data.approveDate = this.getDate(data.data.approveDate)
        data.data.birthday = this.getDate(data.data.birthday)
        this.userInfo = data.data
        this.userInfo.permium = data.data.currencyCode + data.data.periodTotalPremium
        this.tourl = 'http://release-oss.gc-life.com/gclife/product/jxtx/clause.html'
      }
    })
  },
  methods: {
    handleSend() {
      this.$router.push({
        path: '/SendEmail',
        query: { policyId: this.policyId }
      })
    },
    handleGo() {
      window.location.href = 'http://gclife-hk-release.oss-cn-hongkong.aliyuncs.com/gclife/agent/agreement/content.html'
    },
    getDate(value) {
      const date = new Date(+value);
      return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' +
        date.getDate()
    },
    handlePrint() {
      window.location.href = window.localStorage.gatewayDomain + 'policy/v1/policy/download?policyId=' + this.policyId
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import "./style/index.styl";
</style>



// WEBPACK FOOTER //
// src/pages/PolicyDetail/index.vue